<template>
	<div class="qr-pop">
		<div class="pop-mask" @click="closePop"></div>
		<div class="qr-pop-con">
			<div class="icon">
				<img :src="popData.icon" :alt="popData.txt">
			</div>
			<p>{{popData.txt}}</p>
			<img :src="popData.qr" :alt="popData.txt" class="qr-img">
			<a href="javascript:;" class="back" @click="closePop">{{ $t('back') }}</a>
		</div>
	</div>
</template>

<script>
export default {
	name: "qrPop",
	props: {
		popData: [Object]
	},
	methods: {
		closePop: function () {
			this.$emit('close');
		}
	}
}
</script>

<style scoped lang="scss">
//qr-pop
.qr-pop {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 10000;
}
.pop-mask {
	display: block;
	width: 100%;
	height: 100%;
	background-color: $black;
	opacity: 0.5;
}
.qr-pop-con {
	position: absolute;
	top: 50%;
	left: 50%;
	-webkit-transform: translate(-50%, -50%);
	-moz-transform: translate(-50%, -50%);
	-ms-transform: translate(-50%, -50%);
	transform: translate(-50%, -50%);
	padding: 44px 40px;
	background-color: #fff;
	border-radius: 10px;
	overflow: hidden;
	text-align: center;
	.icon {
		width: 54px;
		overflow: hidden;
		margin: 0 auto;
		img {
			display: block;
			width: 100%;
		}
	}
	p {
		margin: 16px 0;
		@extend .semibold-16px;
	}
	.qr-img {
		display: block;
		width: 280px;
		height: 280px;
		margin: 0 auto 22px;
		border-radius: 10px;
	}
	.back {
		text-decoration: underline;
		font-size: 16px;
		color: $black;
	}
}
@media only screen and (max-width: 767px) {
	.qr-pop-con {
		width: 320px;
		padding: 20px;
	}
}
</style>
